import type { en } from "./en";

export const fr: { [K in keyof typeof en]: string } = {
  close: "Fermer",
  howToPlay: "Comment jouer",
  dash: "Dash",
  duel: "Duel",
  ranks: "Classement",
  garage: "Garage",
  shop: "Boutique",
  settings: "Réglages",
  tagline: "Coursier néon. Ne crash pas.",
  bestMeters: "Record {n} m · {diff}",
  pause: "Pause",
  paused: "Pause",
  resume: "Reprendre",
  endRun: "Terminer",
  sound: "Son",
  on: "On",
  off: "Off",
  muted: "Muet",
  muteSfx: "Couper musique & SFX",
  pbGhost: "Fantôme PB",
  ads: "Pubs",
  adsOff: "Off",
  adsConsentOff: "{mode} · consentement off",
  language: "Langue",
  langEn: "English",
  langFr: "Français",
  langIt: "Italiano",
  langEs: "Español",
  langDe: "Deutsch",
  pseudoRanks: "Pseudo (classement)",
  pseudoHint:
    "Enregistré pour le classement. Modifiable ici à tout moment — pas après chaque course. Pas besoin de compte Apple.",
  gameCenter: "Game Center",
  open: "Ouvrir",
  gcOpening: "Ouverture de Game Center…",
  gcIos: "Game Center est réservé à iOS.",
  gcSignIn: "Connecte-toi à Game Center dans Réglages, puis réessaie.",
  gcHint: "Classements & succès Apple. Séparé du classement in-app.",
  signInApple: "Connexion avec Apple",
  linked: "Lié",
  link: "Lier",
  appleLinked: "Apple lié — le classement suit cet ID.",
  appleLinkedWeb: "Apple lié (test web).",
  appleWaiting: "En attente d’Apple…",
  appleCancel: "Annulé — rien n’a été lié.",
  appleFail:
    "Apple n’a pas terminé (souvent un délai d’index une fois). Joue avec ton pseudo, réessaie plus tard.",
  appleHint:
    "Optionnel. Lie le classement à cet Apple ID sur tes appareils. Pas obligatoire pour jouer.",
  appleLinkedHint: "ID classement lié à Apple. Le pseudo ci-dessus reste modifiable.",
  restorePurchases: "Restaurer les achats",
  restoring: "Restauration…",
  restored: "Achats restaurés (s’il y en a).",
  restoreFail: "Échec de la restauration : {reason}",
  restoreIos: "La restauration est réservée à iOS.",
  appleId: "Apple ID",
  adPrivacy: "Choix pubs",
  manage: "Gérer",
  privacy: "Confidentialité",
  support: "Support",
  settingsHint:
    "Swipe G/D pour changer de voie. Swipe haut pour sauter — ramasse les jetons cyan ↑ (max {n}). Le saut passe barrières, caisses, trous et voitures — pas les camions. Garage → Mondes pour Lune / Magma.",
  playingAs: "Tu joues {name}",
  noPseudo: "Pas encore de pseudo — mets-en un dans Réglages",
  loading: "Chargement…",
  noScores: "Aucun score — sois #1",
  difficultyLocked: "Difficulté verrouillée pour ce duel.",
  diffNote: "Moyen après 3 courses · Difficile après 12. La vitesse monte en course.",
  diffEasy: "Facile",
  diffMedium: "Moyen",
  diffHard: "Difficile",
  hintEasy: "Tranquille",
  hintMedium: "Arcade",
  hintHard: "Insane",
  runsLeft: "{n} courses",
  runLeft: "1 course",
  swipeHint: "Swipe G/D · swipe haut pour sauter",
  swipeHintPower: " · tape ⚡ · maintien = AUTO",
  speedUp: "SPEED UP",
  powerMagnet: "Aimant",
  powerPhase: "Phase",
  powerDefault: "Pouvoir",
  powerOn: "ON",
  powerAuto: "AUTO",
  powerHoldHint: "Tape pour activer · maintien pour AUTO",
  powerAria: "{label}{auto} — maintien pour AUTO",
  powerAriaAuto: " (auto)",
  continueAd: "Continuer (pub)",
  continueFree: "Continuer (gratuit)",
  continueRetry: "Réessayer",
  loadingAd: "Chargement pub…",
  firstContinue: "Le premier continue est gratuit.",
  adsRemovedContinue: "Pubs off — continue gratuit.",
  watchAd: "Regarde une pub pour une chance de plus.",
  leftCount: "({n} restant)",
  outOfContinues: "Plus de continues.",
  duelCrash: "Le premier crash termine le duel.",
  adUnavailable: "Pub indisponible — réessaie ou termine la course.",
  adsBlocked: "Pubs bloquées — autorise-les dans Réglages → Choix pubs, puis réessaie.",
  watchWholeAd: "Regarde la pub jusqu’au bout pour continuer.",
  crash: "Crash !",
  newBest: "Nouveau record !",
  runOver: "Course terminée",
  theyCrashed: "Ils ont crashé d’abord",
  youCrashed: "Tu as crashé d’abord",
  deadHeat: "Égalité",
  duelOver: "Duel terminé",
  vsLasted: " — tu as tenu plus longtemps.",
  vsHeld: " — ils ont tenu plus loin.",
  vsSame: " — même distance.",
  vsLine: "vs {name} {m} m",
  resultCoins: "+{coins} pièces · Record {best} m · {diff}",
  submitting: "Envoi…",
  pickPseudo: "Choisis un pseudo pour le classement",
  offlineScore: "Hors ligne — score sauvé en local",
  rankImproved: "Mondial #{rank} · {total} joueurs",
  rankBestStill: "Record toujours {best} m · #{rank}",
  choosePseudo: "Choisis ton pseudo",
  savePseudo: "Sauver le pseudo",
  asPlayer: "en {name}",
  editSettings: " · modifier dans Réglages",
  rematch: "Revanche",
  playAgain: "Rejouer",
  passPhone: "Passe le téléphone",
  shareInvite: "Partager / Inviter",
  coinsPlus: "+{n} pièces",
  menu: "Menu",
  launchBonus: "Bonus de lancement",
  welcomeTitle: "✦{n} pour toi",
  welcomeBody:
    "Première ouverture de cette version — un peu de fuel pour le Garage. Une seule fois.",
  claimCoins: "Récupérer ✦{n}",
  infoLead: "Coursier néon sur trois voies. Va le plus loin possible — ne crash pas.",
  controls: "Commandes",
  swipeLR: "Swipe G / D",
  swipeLRDesc: " — changer de voie",
  swipeUp: "Swipe haut",
  swipeUpDesc: " — sauter (il faut un jeton)",
  continueInfo: "Continuer",
  continueInfoDesc: " — le premier est gratuit, le second via une pub optionnelle (off en duel)",
  tapPower: "Tape ⚡",
  tapPowerDesc: " — pouvoir du véhicule (ou touche E)",
  twoPlayers: "À 2 joueurs",
  hotseatInfo: "Passe le téléphone",
  hotseatInfoDesc:
    " — après une run, tape {pass}. Ton pote joue la même route ensuite.",
  ranksDuelInfo: "Duel classement",
  ranksDuelInfoDesc:
    " — {ranks} → {duel} sur un score. Tu cours exactement sa route.",
  shareInfo: "Lien d’invite",
  shareInfoDesc:
    " — après une run, {share}. Ton pote ouvre le lien et court ta route.",
  twoPlayersRule:
    "Mêmes obstacles, même seed. Premier crash perd — pas de continue en duel.",
  boardHint:
    "Tape {duel} sur un score pour courir la même route — premier crash perd.",
  resultTwoP: "Jouer avec un pote",
  obstacles: "Obstacles",
  rivalBikes: "Motos rivales",
  rivalDesc: "Saute par-dessus — elles freinent derrière caisses & barrières.",
  trucks: "Camions",
  truckDesc: "Trop hauts pour sauter. Change de voie.",
  barriers: "Barrières",
  barrierDesc: "Saute par-dessus si tu as un jeton.",
  crates: "Caisses",
  crateDesc: "Le saut les passe (certains bolides les explosent).",
  collectibles: "Collectibles",
  coinsTitle: "Pièces (✦)",
  coinsDesc: "Dépense-les au Garage pour débloquer des bolides.",
  jumpTokens: "Jetons de saut",
  jumpDesc: "Stocke jusqu’à {n} — swipe haut pour les user.",
  infoFoot:
    "La vitesse monte pendant la run. Choisis la difficulté avant Dash. {garage} = bolides & mondes. {ranks} = scores & duels. Les missions du jour paient en ✦.",
  missions: "Missions {done}/{total}",
  missionsReady: " · à récupérer",
  claimed: "Récupéré",
  playToStreak: "Joue pour la série",
  dayN: "Jour {n}",
  streakClaim: "Récupérer ✦{n}",
  streakToast: "Série +✦{n}",
  missionToast: "Mission +✦{n}",
  missionClaim: "Récupérer ✦{n}",
  missionDone: "Fait",
  shopTitle: "Boutique",
  noAds: "Sans pubs",
  noAdsBlurb: "Bannières et interstitiels off. Restaurer marche toujours.",
  phantomPack: "Pack Phantom GT",
  phantomPackBlurb: "Phantom GT · ✦{n} · Sans pubs",
  phantomPackGranted: " — déjà donné.",
  phantomPackShort: "Pack Phantom GT · {price}",
  coinPouch: "Sac de pièces",
  coinChest: "Coffre de pièces",
  coinPackBlurb: "✦{n} pour bolides & mondes.",
  owned: "Possédé",
  adsRemoved: "Pubs retirées.",
  adsRemovedWeb: "Pubs retirées (test web).",
  starterUnlocked: "Pack Starter débloqué.",
  starterUnlockedWeb: "Starter débloqué (test web).",
  coinsGranted: "+✦{n} · solde ✦{balance}",
  rides: "Bolides",
  worlds: "Mondes",
  statSpeed: "Vitesse",
  statJump: "Saut",
  statCoins: "Pièces",
  noSpecialPower: "Pas de pouvoir spécial",
  passive: "Passif",
  active: "Actif",
  equip: "Équiper",
  equipped: "Équipé",
  tryRide: "Essayer",
  tryRideHint: "Sans pièces ni classement — juste un essai.",
  practiceHud: "ESSAI",
  practiceOver: "Essai",
  practiceNote: "Ne compte pas — pas de pièces, pas de classement.",
  practiceCrash: "Essai terminé — pas de pièces, pas de classement.",
  tryAgain: "Réessayer",
  backGarage: "Garage",
  getInShop: "Dans la boutique",
  needMore: "Encore ✦{n}",
  buyPrice: "Acheter · ✦ {n}",
  haveCoins: "✦ {price} · Tu as {have}",
  buyCoinsShop: "Acheter des pièces",
  baseCoins: "Pièces de base",
  extraCoins: "+{pct}% pièces",
  higherJump: " · saut plus haut",
  jumpHoles: " · saute les trous",
  prevVehicle: "Véhicule précédent",
  nextVehicle: "Véhicule suivant",
  prevWorld: "Monde précédent",
  nextWorld: "Monde suivant",
  duelBanner:
    "Duel vs {name} · {m} m · {diff} · {stage} — même route, premier crash perd.",
  cancel: "Annuler",
  vsHud: "vs {name} {m}m",
  iapProductUnavailable:
    "Produit indisponible : Apple n’a pas encore validé l’IAP (Ready to Submit). Les produits existent déjà — pas besoin de les recréer. Ils seront en vente après la review.",
  iapStoreUnavailable:
    "Store indisponible — réessaie sur un vrai appareil avec un Apple ID sandbox.",
  iapFailed: "Achat échoué : {reason}",
  shareDialog: "Partager & inviter des amis",
  shareCopied: "Score + lien d’invite copiés !",
  shareNamed:
    "{who} a dashé {meters}m{diff} dans 3Dash — premier crash perd.{challenge}",
  shareAnon:
    "J’ai dashé {meters}m et chopé {coins} pièces dans 3Dash{diff}. Bats mon run !{challenge}",
  shareChallenge: " Même route : {url}",
  mission_play3: "Finis 3 courses",
  mission_reach400: "Atteins 400 m en une course",
  mission_coins20: "Ramasse 20 pièces aujourd’hui",
  mission_jumps8: "Saute 8 fois aujourd’hui",
  mission_beatBest: "Bats ton record",
  veh_dash_blurb: "Hoverbike de série. Équilibré et gratuit.",
  veh_bulldog_blurb: "Châssis lourd. Lent, mais les caisses n’ont aucune chance.",
  veh_falcon_blurb: "Cadre léger, fait pour voler.",
  veh_magneto_blurb: "Aspi à pièces pour les longs farm.",
  veh_wasp_blurb: "Cadre dard. Plus vif, plus nerveux, zéro gadget.",
  veh_phantom_blurb: "Vitesse max. Traverse tout — un instant.",
  pow_none: "Pas de pouvoir spécial.",
  pow_none_wasp: "Pas de pouvoir — juste le rythme.",
  pow_crush: "Écrase les caisses au contact. Barrières & rivaux font toujours mal.",
  pow_glider: "Planeur — saut +60 % plus long et plus haut.",
  pow_magnet: "Aimant à pièces 6 s. Recharge 20 s.",
  pow_phase: "Phase 3 s — traverse tous les obstacles. Recharge 30 s.",
  stage_neon: "Neon City",
  stage_lunar: "Lunar Dust",
  stage_volcano: "Magma Run",
  stage_ice: "Ice Flats",
  stage_neon_blurb: "Voies mouillées. Le run classique de 3Dash.",
  stage_lunar_blurb: "Faible gravité — les sauts flottent. +25 % pièces.",
  stage_volcano_blurb: "Fissures de lave — saute les trous. +50 % pièces.",
  stage_ice_blurb: "Vitesse blizzard. Grands sauts, trous de glace. +20 % pièces.",
};
